import React, { useState ,useEffect} from 'react';
import DynamicIcon from '../components/DynamicIcon'

const TablaDatosModulos = ({ datos, onEdit, onDelete }) => {
  const [permisosData, setPermisosData] = useState([]);
  const [expandedIds, setExpandedIds] = useState(new Set());
    // Normaliza claves "permisos" a "Permisos"
    const normalizePermisosKeys = (data) => {
      return data.map(item => ({
        ...item,
        Permisos: normalizePermisosKeys(item.permisos || []),
      }));
    };
        useEffect(() => {
          if (datos) {
            const normalized = normalizePermisosKeys(datos);
            setPermisosData(normalized);
            console.log(normalized);
          }
        }, [datos]);
        const toggleExpand = (id) => {
          setExpandedIds((prev) => {
            const newSet = new Set(prev);
            newSet.has(id) ? newSet.delete(id) : newSet.add(id);
            return newSet;
          });
        };
      
        const updateAllChildrenPermissions = (children, checked) => {
          return children.map(child => ({
            ...child,
            Permiso: checked,
            Permisos: updateAllChildrenPermissions(child.Permisos, checked),
          }));
        };
      
        const handleCheckboxChange = (id, checked, data = permisosData) => {
          return data.map(item => {
            if (item.Id === id) {
              return {
                ...item,
                Permiso: checked,
                Permisos: updateAllChildrenPermissions(item.Permisos, checked),
              };
            }
            return {
              ...item,
              Permisos: handleCheckboxChange(id, checked, item.Permisos),
            };
          });
        };
      
        const onCheckboxToggle = (id, checked) => {
          setPermisosData(prev => handleCheckboxChange(id, checked, prev));
        };
      
        const extractPermisos = (data) => {
          const result = [];
          const recurse = (nodes) => {
            for (const node of nodes) {
              result.push(node);
              if (node.Permisos && node.Permisos.length > 0) {
                recurse(node.Permisos);
              }
            }
          };
          recurse(data);
          return result;
        };
              
        const renderModulos = (data, level = 0) => {
          return data.flatMap(item => {
            const isExpanded = expandedIds.has(item.Clave);
            const hasChildren = item.Menus && item.Menus.length > 0;
        
            return [
              <tr key={item.Id} className="border-b hover:bg-gray-50">
                <td className="py-1 text-gray-700">
                  <div className="flex items-center gap-2" style={{ paddingLeft: `${level * 24}px` }}>
                    <span className={`px-2 gap-2 flex font-${level === 0 ? 'semibold' : level === 1 ? 'medium' : 'normal'}`}>
                      <DynamicIcon iconName={item.Icono} color="text-green-800" size="1.5rem" />
                      {item.Titulo}
                    </span>
                  </div>
                </td>
                <td>
                  {hasChildren && (
                    <button
                      onClick={() => toggleExpand(item.Clave)}
                      className="focus:outline-none text-sm"
                      title={isExpanded ? "Colapsar" : "Expandir"}
                    >
                      {isExpanded
                        ? <DynamicIcon iconName="chevrondown" size="1.5rem" />
                        : <DynamicIcon iconName="chevronright" size="1.5rem" />}
                    </button>
                  )}
                </td>
                <td className="text-center"></td>
                <td className="text-center">
                  {item.Id>4?<button
                    onClick={() => onEdit(item)}
                    className="text-blue-600 hover:underline"
                  >
                    <DynamicIcon iconName="edit" color="text-green-800" size="1.5em" />
                  </button>:<button><DynamicIcon iconName="edit" color="text-gray-300" size="1em" /></button>}
                 {item.Id>4?<button
                    onClick={() => onDelete(item)}
                    className="text-blue-600 hover:underline"
                  >
                    <DynamicIcon iconName="delete" color="text-red-800" size="1.5em" />
                  </button>:<button><DynamicIcon iconName="delete" color="text-gray-300" size="1em" /></button>}
                </td>
              </tr>,
              ...(hasChildren && isExpanded ? renderModulos(item.Menus, level + 1) : [])
            ];
          });
        };

  return(<>
      <table className="w-[98%] text-left border-collapse">
        <thead className="bg-sidebar-200 text-white sticky top-0 z-10">
          <tr>
          <th className="px-4 py-1">Módulo</th>
          <th className="px-4 py-1"></th><th className="px-4 py-1"></th>
          <th className="text-center px-4 py-1">Acción</th>
          </tr>
        </thead>
          <tbody>
          {renderModulos(permisosData)}         
          </tbody>
      </table>
</>)
    }

export default TablaDatosModulos  